module.exports = __webpack_public_path__ + "media/images/new-tab-icon-5fd49e9a.svg";